import { useState } from 'react';

import { useIsMarketplaceAdminUser } from '../../../configuration/setup/hooks';
import { ActivationSection } from './ActivationSection';
import { BookableResource } from './bookable/BookableResource';
import { DeactivationSection } from './DeactivationSection';
import { DisplayInput } from './DisplayInput';
import { ForcedCancellationProductMultipleAccounts } from './ForcedCancellationProductMultipleAccounts';
import { InputExample } from './InputExample';
import { FALLBACK_BROWSER_INPUT, readAndValidationInputFromBrowser } from './inputReader';
import { ResetActivationSingleProduct } from './reset/ResetActivationSingleProduct';
import type { BrowserInput } from './types';
import { ValidationSection } from './ValidationSection';

export const UtilitiesPage = () => {
    const [input, setInput] = useState<BrowserInput>(FALLBACK_BROWSER_INPUT);
    const isMarketplaceAdminUser = useIsMarketplaceAdminUser();

    return (
        <div className='module-content'>
            <div className={'container-fluid fluid-default'}>
                <div className='list-group'>
                    <div className='list-group-item margin-bottom-10 margin-top-10'>
                        <ResetActivationSingleProduct />
                    </div>
                    <div className='list-group-item margin-bottom-10 margin-top-10'>
                        <BookableResource />
                    </div>

                    {isMarketplaceAdminUser && (
                        <>
                            <div className='list-group-item margin-bottom-10 margin-top-10'>
                                <ForcedCancellationProductMultipleAccounts />
                            </div>
                            <div className='list-group-item'>
                                <InputExample />
                                <button
                                    type={'button'}
                                    className={'btn btn-primary margin-20'}
                                    onClick={() => setInput(readAndValidationInputFromBrowser())}
                                >
                                    Import data from window.input from browser
                                </button>
                                <DisplayInput input={input} />
                            </div>
                            {!input.error && (
                                <div>
                                    <div className='list-group-item margin-bottom-10 margin-top-10'>
                                        <ValidationSection activationItems={input.items} />
                                    </div>
                                    <div className='list-group-item margin-bottom-10 margin-top-10'>
                                        <ActivationSection input={input} />
                                    </div>
                                    <div className='list-group-item margin-bottom-10 margin-top-10'>
                                        <DeactivationSection input={input} />
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
